import React from 'react';
import { Button } from '@ag1/ui';
import { EduHubSettingsResult } from 'types/studio/eduHub';
import { CustomPortableText } from 'shared/studio/PortableText';
import styles from './LoadMoreArticlesButton.module.scss';

interface Props {
  loadMoreButton: EduHubSettingsResult['loadMoreButton'];
  onClick: () => void;
}

export const LoadMoreArticlesButton = ({ loadMoreButton, onClick }: Props) =>
  loadMoreButton ? (
    <div className={styles.root}>
      <Button
        size="medium"
        rounded
        variant={loadMoreButton.variant}
        className={styles.button}
        icon={loadMoreButton.showIcon && loadMoreButton.iconOptions?.icon}
        iconPosition={loadMoreButton.iconOptions?.position}
        onClick={onClick}
        theme="new">
        {loadMoreButton.portableText && <CustomPortableText value={loadMoreButton.portableText} />}
      </Button>
    </div>
  ) : null;
